// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3X0-U","info":"PatientInfo_info__2TRPR"};